import React from 'react'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'



const Tutorial = (props) => {
    console.log(props)
    return(
        <div>
            { props.tutorial ? (
                <Card >
                    <CardMedia style={{height: 0, paddingTop: '56.25%'}}
                    image={props.tutorial.fields.tutorialmedia.fields.file.url}
                    />
                    <CardContent>
                    <Typography gutterBottom variant="headline" component="h6">
                        {props.tutorial.fields.title}
                    </Typography>
                    </CardContent>
                    <CardActions>
                        <Typography gutterBottom>
                            <Link to={{ pathname: '/tutorialdetails/'+props.tutorial.fields.slug}} style={{textDecoration:'none'}}>
                                <Button variant="contained" color="primary"  style={{background: '#2E3B55'}}>
                                    View Details
                                </Button>
                            </Link>
                        </Typography>
                    </CardActions>
                </Card>
            ) : null}
        </div>
    )
}
export default Tutorial




// WEBPACK FOOTER //
// ./src/components/Tutorials/Tutorial.js